/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerSuccessInfo
 */
export interface CustomerSuccessInfo {
    /**
     * 
     * @type {string}
     * @memberof CustomerSuccessInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerSuccessInfo
     */
    email?: string;
}

/**
 * Check if a given object implements the CustomerSuccessInfo interface.
 */
export function instanceOfCustomerSuccessInfo(value: object): value is CustomerSuccessInfo {
    return true;
}

export function CustomerSuccessInfoFromJSON(json: any): CustomerSuccessInfo {
    return CustomerSuccessInfoFromJSONTyped(json, false);
}

export function CustomerSuccessInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerSuccessInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function CustomerSuccessInfoToJSON(json: any): CustomerSuccessInfo {
    return CustomerSuccessInfoToJSONTyped(json, false);
}

export function CustomerSuccessInfoToJSONTyped(value?: CustomerSuccessInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
    };
}

